import { useQuery } from '@apollo/client';
import { isNil, sortBy } from 'lodash';
import { useContext, useMemo } from 'react';
import { Queries } from '@shared/api';
import { CardChannelContext } from '@shared/scenes/cards/context';
import { API } from '@shared/types/api';

export interface TagOption {
  id: string;
  value: string;
  label: string;
  backgroundColor: string;
  archived: boolean;
  fieldName: string;
  sortKey: string;
}

interface UseTagOptionsResponse {
  options: TagOption[];
  refetch(): void;
  loading: boolean;
}

function toTagOption(tag: API.TagOptionFragment): TagOption {
  return {
    id: tag.id,
    value: tag.slug,
    label: tag.label,
    backgroundColor: tag.colorName,
    archived: !isNil(tag.archivedAt),
    fieldName: tag.fieldName,
    sortKey: tag.sortKey,
  };
}

/**
 * @deprecated Use useWorkflowTagOptions or useCombinedTagOptions from @shared/util/hooks/useWorkflowTagOptions instead.
 */
export function useAllTagOptions(skip = false): UseTagOptionsResponse {
  const channel = useContext(CardChannelContext);
  const { data, loading, refetch } = useQuery<
    API.ListCardFieldStringTagsQuery,
    API.ListCardFieldStringTagsQueryVariables
  >(Queries.card.listCardFieldStringTags, {
    variables: {
      input: { channelId: channel?.id ?? -1 },
    },
    skip: skip || isNil(channel?.id),
  });

  const options = useMemo(() => {
    const tags: API.TagOptionFragment[] = data?.tags ?? [];
    return sortBy(tags, 'sortKey').map(toTagOption);
  }, [data?.tags]);

  return { options, loading, refetch };
}
